export default __webpack_public_path__ + "static/media/no-cars.38b84430.svg";